import { observer } from 'mobx-react-lite'
import { RevertDialog } from '@/features/legends/versioning/RevertDialog'
import type { RevertDialogViewModel } from './RevertDialogViewModel'

const testId = 'legend-revert-dialog'

export interface RevertDialogContainerProps {
  vm: RevertDialogViewModel
  version: number
}

export const RevertDialogContainer = observer(function RevertDialogContainer({
  vm,
  version,
}: RevertDialogContainerProps) {
  return (
    <RevertDialog
      showing={vm.modal.showing}
      version={version}
      onConfirm={vm.confirm}
      onDecline={vm.decline}
      confirmButtonTestId={`${testId}-confirm`}
    />
  )
})
